module.exports = __webpack_public_path__ + "2141ef7a0b82058a9efaf3827bdfed50.pdf";